module.exports = {
    values: {}
}
